<script>
import InputField from '@/components/general/InputField'
import UserListItem from '@/components/general/UserListItem'
import EmptyList from '@/components/general/EmptyList'
import ModalInviteMember from './ModalInviteMember'
import Loading from '@/components/general/Loading.vue'
export default {
  components: { InputField, UserListItem, EmptyList, ModalInviteMember, Loading },
  name: 'ActiveUsers',
  data () {
    return {
      search: '',
      isReady: false,
      users: [],
      data: [],
      showModalInvite: false
    }
  },
  created () {
    this.getActiveUsers()
  },
  methods: {
    getActiveUsers () {
      this.$store.dispatch('attemptGetUsers')
        .then(({ data }) => {
          this.isReady = true
          this.users = data.users.filter(u => u.active).map((user) => (
            {
              id: user.id,
              name: user.fullName,
              lastName: user.fullName.split(' ').slice(1).join(' '),
              email: user.email,
              active: user.active,
              avatarImage: user.avatar.indexOf('/empty') === -1 ? user.avatar : '/assets/images/profile-avatar.jpg',
              role: user.role,
              status: !user.activeLogin && user.active ? 'waiting.first.access' : '',
              approvalFlowSteps: user.approvalFlowSteps,
              dependent: user.dependent
            }
          ))
          this.users.sort((a, b) => a.name.localeCompare(b.name))
          this.data = this.users
        })
    },
    closeInviteModal () {
      this.showModalInvite = false
    }
  },
  watch: {
    search: function (value) {
      this.users = this.data.filter(user => {
        return user.name.toLowerCase().indexOf(value.toLowerCase()) > -1
      })
    }
  }
}
</script>
<template>
  <div>
    <Loading v-if="!isReady"/>
    <div class="active-users--container" v-else>
      <div class="active-users--filter-actions">
        <input-field class="mr-2" outlined dense :label="$t('global:search.alt')" v-model="search" append-icon="mdi-magnify"></input-field>
        <v-btn class="btn transform-unset" :color="getPrimaryColor" dark @click="showModalInvite = true"><v-icon size="18px" class="mr-2" color="#fff">mdi-plus</v-icon>{{ $t('admin.center.users:add.user.btn') }}</v-btn>
      </div>
      <div class="active-users--list">
        <empty-list
          v-if="users.length === 0"
          :title="$t('empty.state.title:active.user.active.title')"
          :textOne="$t('empty.state.text:active.user.active.text')"
          :image="'/assets/images/empty-bush.png'"
        ></empty-list>
        <user-list-item v-for="user in users" :key="user.id" :user="user" @userDeleted="getActiveUsers()"></user-list-item>
      </div>
      <modal-invite-member :show="showModalInvite" @close="closeInviteModal"/>
      <router-view></router-view>
    </div>
  </div>
</template>
<style lang="scss">
.active-users--container {
  .active-users--filter-actions {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
